import { render, staticRenderFns } from "./proxy-list.vue?vue&type=template&id=57cf85d3&scoped=true&"
import script from "./proxy-list.vue?vue&type=script&lang=js&"
export * from "./proxy-list.vue?vue&type=script&lang=js&"
import style0 from "./proxy-list.vue?vue&type=style&index=0&id=57cf85d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf85d3",
  null
  
)

export default component.exports